import { useBilling } from "@/hooks/useBilling";
import { Clock, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const TrialBanner = () => {
  const { isTrialing, isTrialExpired, isPastDue, isCancelled, cancelledButActive, cancelledDaysLeft, trialDaysLeft, loading } = useBilling();
  const { t } = useLanguage();

  if (loading) return null;

  if (isPastDue) {
    return (
      <div className="bg-destructive/10 border-b border-destructive/20 px-4 py-2 flex items-center justify-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4 text-destructive" />
        <span className="text-destructive font-medium">
          {t("banner.payment_failed")}{" "}
          <Link to="/dashboard/settings/billing" className="underline hover:no-underline">
            {t("banner.update_payment")}
          </Link>
        </span>
      </div>
    );
  }

  if (cancelledButActive) {
    return (
      <div className="bg-warning/10 border-b border-warning/20 px-4 py-2 flex items-center justify-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4 text-warning" />
        <span className="text-warning font-medium">
          {t("banner.cancelled").replace("{days}", String(cancelledDaysLeft))}{" "}
          <Link to="/dashboard/settings/billing" className="underline hover:no-underline">
            {t("banner.reactivate")}
          </Link>
        </span>
      </div>
    );
  }

  if (isTrialExpired) {
    return (
      <div className="bg-destructive/10 border-b border-destructive/20 px-4 py-2 flex items-center justify-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4 text-destructive" />
        <span className="text-destructive font-medium">
          {t("banner.trial_expired")}{" "}
          <Link to="/dashboard/settings/billing" className="underline hover:no-underline">
            {t("banner.setup_payment")}
          </Link>
        </span>
      </div>
    );
  }

  if (isTrialing) {
    const isUrgent = trialDaysLeft <= 7;
    return (
      <div className={`border-b px-4 py-2 flex items-center justify-center gap-2 text-sm ${
        isUrgent ? "bg-warning/10 border-warning/20" : "bg-primary/5 border-primary/10"
      }`}>
        <Clock className={`h-4 w-4 ${isUrgent ? "text-warning" : "text-primary"}`} />
        <span className={`font-medium ${isUrgent ? "text-warning" : "text-primary"}`}>
          {t("banner.trial").replace("{days}", String(trialDaysLeft))}{" "}
          <Link to="/dashboard/settings/billing" className="underline hover:no-underline">
            {t("banner.setup_payment")}
          </Link>
        </span>
      </div>
    );
  }

  return null;
};

export default TrialBanner;
